module.exports = __webpack_public_path__ + "images/strikebowling-1b61d49388aa096639416fb61d0bee05.png";